function Blog(){
    return (
            <section className="py-5">
                <div className="container">
                    <div className="row justify-content-center text-center mb-4 mb-md-5">
                    <div className="col-xl-9 col-xxl-8">
                        <span className="text-muted">Read More</span>
                        <h2 className="display-5 fw-bold">Our Blog</h2>
                        <p className="lead">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                        eiusmod tempor incididunt ut labore et dolore magna aliqua
                        </p>
                    </div>
                    </div>
                    <div className="row align-items-center gy-md-5">
                    <div className="col-md-6">
                        <div className="mt-4 mt-md-0">
                        <img
                            alt=""
                            className="img-fluid rounded my-md-0 my-4"
                            src="https://freefrontend.dev/assets/rectangle-wide.png"
                        />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <a className="text-primary fw-semibold text-decoration-none" href="">
                        Category
                        </a>
                        <h2 className="fw-semibold my-1">A short engaging title</h2>
                        <div className="text-muted">10.10.2017</div>
                        <p className="my-4">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum
                        congue risus sit amet dictum malesuada. Vestibulum viverra iaculis
                        turpis, vitae varius lectus imperdiet at. Sed ultrices, ante vitae
                        maximus laoreet, magna quam tincidunt ex, non faucibus justo dui
                        commodo libero.
                        </p>
                        <a className="btn-link" href="">
                        Read more
                        </a>
                    </div>
                    <div className="col-md-6">
                        <div className="mt-4 mt-md-0">
                        <img
                            alt=""
                            className="img-fluid rounded my-md-0 my-4"
                            src="https://freefrontend.dev/assets/rectangle-wide.png"
                        />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <a className="text-primary fw-semibold text-decoration-none" href="">
                        Category
                        </a>
                        <h2 className="fw-semibold my-1">A short engaging title</h2>
                        <div className="text-muted">10.10.2017</div>
                        <p className="my-4">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum
                        congue risus sit amet dictum malesuada. Vestibulum viverra iaculis
                        turpis, vitae varius lectus imperdiet at. Sed ultrices, ante vitae
                        maximus laoreet, magna quam tincidunt ex, non faucibus justo dui
                        commodo libero.
                        </p>
                        <a className="btn-link" href="">
                        Read more
                        </a>
                    </div>
                    <div className="col-md-6">
                        <div className="mt-4 mt-md-0">
                        <img
                            alt=""
                            className="img-fluid rounded my-md-0 my-4"
                            src="https://freefrontend.dev/assets/rectangle-wide.png"
                        />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <a className="text-primary fw-semibold text-decoration-none" href="">
                        Category
                        </a>
                        <h2 className="fw-semibold my-1">A short engaging title</h2>
                        <div className="text-muted">10.10.2017</div>
                        <p className="my-4">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum
                        congue risus sit amet dictum malesuada. Vestibulum viverra iaculis
                        turpis, vitae varius lectus imperdiet at. Sed ultrices, ante vitae
                        maximus laoreet, magna quam tincidunt ex, non faucibus justo dui
                        commodo libero.
                        </p>
                        <a className="btn-link" href="">
                        Read more
                        </a>
                    </div>
                    </div>
                </div>
            </section>
    );
}

export default Blog